<div class="px-3">
    <label>{{ field.name }}:</label>
    <span>{{ recordNames }}</span>
</div>
